import { render, staticRenderFns } from "./HomePage2.vue?vue&type=template&id=3814bdf7&scoped=true&"
import script from "./HomePage2.vue?vue&type=script&lang=js&"
export * from "./HomePage2.vue?vue&type=script&lang=js&"
import style0 from "./HomePage2.vue?vue&type=style&index=0&id=3814bdf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814bdf7",
  null
  
)

export default component.exports